// @flow
import profileService from './profileService';
import profileActionKeys from './profileActionKeys';
import * as advertiseService from '../../../app/common/advertise/advertiseService';
import type {
  GetProfileRequest,
  SaveContactInfoRequest,
  GetProfileCompletionRequests,
  GetProfileRequestUAPI, BusinessHighlightUAPI, AmenitiesUAPI,
} from './profileService';

export const getServiceProviderCurrentProfile = ({
  serviceProviderId,
}: GetProfileRequest):
{|payload: {|data: {|serviceProviderId: string|}, promise: any|}, type: any|} => ({
  type: profileActionKeys.GET_PROFILE,
  payload: {
    data: { serviceProviderId },
    promise: profileService.getServiceProviderCurrentProfile({
      serviceProviderId,
    }),
  },
});

export const getUUIDBySpId = (serviceProviderId: string):
  {|payload: {|data: {|serviceProviderId: string|}, promise: any|}, type: any|} => ({
  type: profileActionKeys.GET_PROFILE_UUID,
  payload: {
    data: { serviceProviderId },
    promise: profileService.getUUIDBySpId(serviceProviderId),
  },
});


export const getServiceProviderProfile = (request: GetProfileRequestUAPI):
  {|payload: {|data: {|uuid: string|}, promise: any|}, type: any|} => ({
  type: profileActionKeys.GET_PROFILE_UAPI,
  payload: {
    data: { uuid: request.uuid },
    promise: profileService.getServiceProviderProfile(request),
  },
});

export const getProfileCompletionInfo = ({
  serviceProviderId,
} :GetProfileCompletionRequests):
{|payload:{|data: {|serviceProviderId: string|}, promise: any|}, type: any|} => ({
  type: profileActionKeys.GET_PROFILE_COMPLETION,
  payload: {
    data: { serviceProviderId },
    promise: profileService.getProfileCompletionInfo({ serviceProviderId }),
  },
});


const getCategoryAutocomplete = (serviceProviderId: number, query: string, size: number):
{|payload: any, type: any|} => ({
  type: profileActionKeys.GET_CATEGORY_AUTOCOMPLETE,
  payload: profileService.getCategoryAutocomplete(serviceProviderId, query, size),
});

const createTradeLicenseInfo =
  (serviceProviderId: number, UAPI_UUID: string, tradeLicenseInfo: Object): {|
  payload: {|
    data: {|
      tradeLicenseInfo: Object,
    |},
    promise: Promise<any>,
  |},
  type: any,
|} => ({
    type: profileActionKeys.CREATE_LICENSE,
    payload: {
      data: { tradeLicenseInfo },
      promise: profileService.createTradeLicenseInfo(
        serviceProviderId,
        UAPI_UUID,
        tradeLicenseInfo,
      ),
    },
  });

const deleteTradeLicenseInfo =
  (serviceProviderId: number, UAPI_UUID: string, tradeLicenseInfoId: number): {|
  payload: {|
    data: {|
      serviceProviderId: number,
      tradeLicenseInfoId: number
    |},
    promise: Promise<any>,
  |},
  type: any,
  meta: {|tradeLicenseInfoId: number|}
|} => ({
    type: profileActionKeys.DELETE_LICENSE,
    payload: {
      data: { serviceProviderId, tradeLicenseInfoId },
      promise: profileService.deleteTradeLicenseInfo(
        serviceProviderId,
        UAPI_UUID,
        tradeLicenseInfoId,
      ),
    },
    meta: { tradeLicenseInfoId },
  });

const updateTradeLicenseInfo =
  (
    serviceProviderId: number,
    UAPI_UUID: string,
    tradeLicenseInfo: Object,
  ): {|
  payload: {|
    data: {|tradeLicenseInfo: Object|},
    promise: Promise<any>,
  |},
  type: any,
|} => ({
    type: profileActionKeys.UPDATE_LICENSE,
    payload: {
      data: { tradeLicenseInfo },
      // eslint-disable-next-line
      promise: profileService.updateTradeLicenseInfo(serviceProviderId, UAPI_UUID,
        tradeLicenseInfo,
      ),
    },
  });

const createLicenseReset = (): {| type: any |} => ({
  type: profileActionKeys.CREATE_LICENSE_RESET,
});

const updateLicenseReset = (): {| type: any |} => ({
  type: profileActionKeys.UPDATE_LICENSE_RESET,
});

const updateTradeLicenseAttestation =
  (serviceProviderId: string | number, attestationDate: string): {|
  payload: {|
    data: {|attestationDate: string|},
    promise: Promise<any>,
  |},
  type: any,
|} => ({
    type: profileActionKeys.UPDATE_LICENSE_ATTESTATION,
    payload: {
      data: { attestationDate },
      promise: profileService.updateTradeLicenseAttestation(serviceProviderId, attestationDate),
    },
  });

const getThimbleUrl = (serviceProviderId: number, postalCode: string, categoryId ?: number):
{|payload: any, type: any|} => ({
  type: profileActionKeys.GET_THIMBLE_URL,
  payload: profileService.getThimbleUrl(serviceProviderId, postalCode, categoryId),
});

const saveAbout =
  (
    serviceProviderId: number,
    UAPI_UUID: string,
    inBusinessSince: number,
    description: string,
    businessHighlight?: BusinessHighlightUAPI[],
  ):
    {|
      payload: {|
        data: {
          UAPI_UUID: string,
          description: string,
          inBusinessSince: number,
          businessHighlight?: BusinessHighlightUAPI[],
          serviceProviderId: number,
        },
        promise: any,
      |},
      type: any,
    |} => ({
    type: profileActionKeys.SAVE_PROFILE,
    payload: {
      data: {
        UAPI_UUID, inBusinessSince, description, businessHighlight, serviceProviderId,
      },
      promise: profileService.saveAbout(
        serviceProviderId, UAPI_UUID,
        inBusinessSince, description, businessHighlight,
      ),
    },
  });

const saveAboutSegmentation =
(
  serviceProviderId: number,
  UAPI_UUID: string,
  description: string,
  businessHighlight?: BusinessHighlightUAPI[],
):
  {|
    payload: {|
      data: {
        UAPI_UUID: string,
        description: string,
        businessHighlight?: BusinessHighlightUAPI[],
        serviceProviderId: number,
      },
      promise: any,
    |},
    type: any,
  |} => ({
  type: profileActionKeys.SAVE_PROFILE,
  payload: {
    data: {
      UAPI_UUID, description, businessHighlight, serviceProviderId,
    },
    promise: profileService.saveAboutSegmentation(
      serviceProviderId,
      UAPI_UUID,
      description,
      businessHighlight,
    ),
  },
});

// by  Appointment, open 24/7, Hours[] / closed
const saveBusinessHours =
(serviceProviderId: number, UAPI_UUID: string, values: Object): {|
  payload: {|
    data: {|
      serviceProviderId: number,
      UAPI_UUID: string,
      values: any|},
    promise: any|},
  type: any,
|} => ({
  type: profileActionKeys.SAVE_PROFILE,
  payload: {
    data: { serviceProviderId, UAPI_UUID, values },
    promise: profileService.saveBusinessHours(serviceProviderId, UAPI_UUID, values),
  },
});

const saveContactInformation =
(serviceProviderId: string | number, UAPI_UUID: string, values: SaveContactInfoRequest): {|
  payload: {|
    data: {|
      serviceProviderId: string | number,
      UAPI_UUID: string,
      values: SaveContactInfoRequest|},
    promise: any,
  |},
  type: any,
|} => ({
  type: profileActionKeys.SAVE_PROFILE,
  payload: {
    data: { serviceProviderId, UAPI_UUID, values },
    promise: profileService.saveContactInformation(serviceProviderId, UAPI_UUID, values),
  },
});

const saveServices =
(serviceProviderId: number, UAPI_UUID: string, values: Object): {|
  payload: {|
    data: {|
      serviceProviderId: string | number,
      UAPI_UUID: string,
      values: any|},
    promise: any,
  |},
  type: any,
|} => ({
  type: profileActionKeys.SAVE_PROFILE,
  payload: {
    data: { serviceProviderId, UAPI_UUID, values },
    promise: profileService.saveServices(serviceProviderId, UAPI_UUID, values),
  },
});

const saveStep3 =
  (
    serviceProviderId: number, UAPI_UUID: string, amenities: AmenitiesUAPI,
    businessHighlight: BusinessHighlightUAPI[],
  ):
    {|
      payload: {|
        data: {
          UAPI_UUID: string,
          amenities: AmenitiesUAPI,
          businessHighlight: BusinessHighlightUAPI[],
          serviceProviderId: number,
        },
        promise: any,
      |},
      type: any,
    |} => ({
    type: profileActionKeys.SAVE_PROFILE,
    payload: {
      data: {
        UAPI_UUID, amenities, businessHighlight, serviceProviderId,
      },
      promise: profileService.saveStep3(
        serviceProviderId, UAPI_UUID,
        amenities, businessHighlight,
      ),
    },
  });

const saveProfileReset = (): {| type: any |} => ({
  type: profileActionKeys.SAVE_PROFILE_RESET,
});

const saveBondedInsured =
  (serviceProviderId: number, UAPI_UUID: string, isBonded: boolean, isInsured: boolean): {|
    payload: {|
      data: {|
        serviceProviderId: number,
        isBonded: boolean,
        isInsured: boolean
      |},
      promise: any,
    |},
    type: any,
  |} => ({
    type: profileActionKeys.SAVE_BONDED_INSURED,
    payload: {
      data: { serviceProviderId, isBonded, isInsured },
      promise: profileService.saveBondedInsured(serviceProviderId, UAPI_UUID, isBonded, isInsured),
    },
  });

const getShowcases =
(serviceProviderId: string | number, statuses: string[]): {|
  payload: {|data: {|serviceProviderId: string | number|}, promise: any|},
  then: (resp: any) => void,
  type: any,
|} => ({
    then: (resp: any) => {},
    type: profileActionKeys.GET_SHOWCASES,
    payload: {
      data: { serviceProviderId },
      promise: profileService.getShowcases(serviceProviderId, statuses),
    },
  });

const archiveShowcase = (showcaseId: number, serviceProviderId: string | number): {|
  meta: {|showcaseId: number|},
  payload: {|
    data: {|serviceProviderId: string | number, showcaseId: number|},
    promise: any,
  |},
  type: any,
|} => ({
  type: profileActionKeys.ARCHIVE_SHOWCASE,
  payload: {
    data: { showcaseId, serviceProviderId },
    promise: profileService.archiveShowcase(showcaseId, serviceProviderId),
  },
  meta: { showcaseId },
});

const getAllBusinessHighlights = (): {|payload: any, type: any|} => ({
  type: profileActionKeys.GET_ALL_BUSINESS_HIGHLIGHTS,
  payload: profileService.getAllBusinessHighlights(),
});

const showcaseAdvertiseRequest = (
  activityLocation?: string,
  description?: string,
  categorySegmentData?: Object,
): {|
  meta: {|
    activityLocation: void | string,
    categorySegmentData: any | void,
    description: void | string,
  |},
  payload: {|promise: any|},
  type: any,
|} => ({
  type: profileActionKeys.SHOWCASE_ADVERTISE_REQUEST,
  payload: {
    promise: advertiseService.advertiseRequest(),
  },
  meta: {
    activityLocation,
    description,
    categorySegmentData,
  },
});

export default {
  archiveShowcase,
  getCategoryAutocomplete,
  createTradeLicenseInfo,
  deleteTradeLicenseInfo,
  updateTradeLicenseInfo,
  updateTradeLicenseAttestation,
  getServiceProviderCurrentProfile,
  getServiceProviderProfileCompletion: getProfileCompletionInfo,
  getServiceProviderProfile,
  getShowcases,
  getThimbleUrl,
  saveAbout,
  saveAboutSegmentation,
  saveBusinessHours,
  saveContactInformation,
  saveServices,
  saveStep3,
  saveProfileReset,
  saveBondedInsured,
  showcaseAdvertiseRequest,
  getAllBusinessHighlights,
  updateLicenseReset,
  createLicenseReset,
  getUUIDBySpId,
};



// WEBPACK FOOTER //
// ./src/modules/profile/common/profileActions.js